import React, {useState, useEffect} from "react";
import ModalComponent from '../ModalComponent';
import ModalRoot from "../ModalRoot";
import ControlGroup from "../forms/ControlGroup";
import registeredComponent from "utils/registeredComponent";
import {Button} from "react-bootstrap";
import {modals, customers, splitDeposits, billingConfigs as billingConfigsDuck} from "ducks";
import {singleDuck, duckify, filterDuck, dependentDuck} from "utils/duckify";
import Placeholder from '../Placeholder';
import ValidationErrors from '../forms/ValidationErrors';
import DatePicker from "react-datepicker";
import {apiFetch} from 'utils';
import moment from 'moment';

const ManualPayment = (props) => {
  const {contactId, checklistAnswerId, customer, allDucksReady, backboneEventHandler, splitDeposit, billingConfig} = props;

  if(!allDucksReady) {
    return <Placeholder.loading ready={false}/>;
  }

  const paymentValues = customer.payment_config.payment_methods;
  // We only send the display name to the backbone object, so this parses the canonical name out based on display name
  const paymentMatch = Object.values(paymentValues).find(obj => props.paymentMethod === obj.display_name);
  const currentPaymentMethod = paymentMatch ? paymentMatch.canonical_name : "";

  const [paymentAmount, setAmount] = useState(splitDeposit.deposit_amount || 0);
  const [paymentMethod, setMethod] = useState(currentPaymentMethod || "");
  const [completionDate, setCompletionDate] = useState(undefined);
  const [receivedDate, setReceivedDate] = useState(undefined);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  const minDate = billingConfig && billingConfig.ledger_lock
    ? moment(billingConfig.ledger_lock).add(1, 'day').toDate()
    : undefined;

  const save = () => {
    setSaving(true)
    let currentErrors = checkErrors();
    if (Object.keys(currentErrors).length <= 0) {
      const {dispatch} = props;
      const token = $('meta[name="csrf-token"]').attr('content');

      dispatch(splitDeposits.actions.completeManualPayment(splitDeposit, paymentMethod, completionDate))
      .then(() => fetch('/checklist_answers/' + checklistAnswerId, {
        method: 'GET',
        headers: {'Content-Type': 'application/json',  'X-CSRF-Token': token},
        credentials: 'include'
      }))
      .then(response => response.json())
      .then(checklist_answer => {
        backboneEventHandler.trigger('MODAL_SUBMIT', checklist_answer);
        dispatch(modals.actions.hide());
        setSaving(false)
      });
    } else {
      setSaving(false)
    }
  };

  const clear = () => {
    setSaving(true);
    const {dispatch} = props;
    const token = $('meta[name="csrf-token"]').attr('content');

    dispatch(splitDeposits.actions.unCompleteManualPayment(splitDeposit))
      .then(() => fetch('/checklist_answers/' + checklistAnswerId, {
        method: 'GET',
        headers: {'Content-Type': 'application/json',  'X-CSRF-Token': token},
        credentials: 'include'
      }))
      .then(response => response.json())
      .then(checklist_answer => {
        backboneEventHandler.trigger('MODAL_SUBMIT', checklist_answer);
        dispatch(modals.actions.hide());
        setSaving(false)
      });
  };

  const checkErrors = () => {
    let currentErrors = {};

    if (paymentMethod.length <= 0 && parseFloat(paymentAmount) > 0) {
      currentErrors = {
        ...currentErrors,
        payment_method: ["not selected. Please choose a payment method and try again"]
      };
    }

    if (parseFloat(paymentAmount) < 0) {
      currentErrors = {...currentErrors, negative_amount: ["not allowed. Amount must be 0 or greater"]}
    }

    if (isNaN(paymentAmount)) {
      currentErrors = {...currentErrors, deposit_amount: ["is not a number"]}
    }
    setErrors(currentErrors);
    return currentErrors
  };


  const buttons = [
    splitDeposit.paid && <Button disabled={saving} variant="danger"
            onClick={() => clear()}>Clear Payment</Button>,
    <Button disabled={saving} variant="primary"
            onClick={() => save()}>Submit</Button>,
  ];

  return (
    <ModalComponent title="Manual Payment" buttons={buttons}>
      <ValidationErrors errors={errors}/>
      <Placeholder.loading ready={allDucksReady}>
        <ControlGroup label="Amount">
          <input id='payment_amount' className='form-control form-control-sm' type={'number'} value={paymentAmount} onChange={(e) => setAmount(e.target.value)} disabled/>
        </ControlGroup>
        <ControlGroup label="Payment Method">
          <select id='payment_method' className='form-select form-select-sm' value={paymentMethod} onChange={(e) => setMethod(e.target.value)}>
            <option value={""}></option>
            {Object.keys(paymentValues).map((payment_method) => {
                if (paymentValues[payment_method].display_name) {
                  return (<option
                    value={paymentValues[payment_method].canonical_name}>{paymentValues[payment_method].display_name}</option>)
                }
              }
            )}
          </select>
        </ControlGroup>

        <ControlGroup label={"Completion Date (optional)"}>
          <DatePicker
            className='form-control form-control-sm datepicker date-filter'
            selected={completionDate}
            onChange={setCompletionDate}
            minDate={minDate}
          />
        </ControlGroup>
        <ControlGroup label={"Payment Received Date (optional)"}>
          <DatePicker
            className='form-control form-control-sm datepicker date-filter'
            selected={receivedDate}
            onChange={setReceivedDate}
          />
        </ControlGroup>
      </Placeholder.loading>
    </ModalComponent>)

};

const mapDucksToProps = (ownProps) => {
  return {
    customer: singleDuck(customers, 'current'),
    splitDeposit: singleDuck(splitDeposits, ownProps.split_deposit_id),
    billingConfig: singleDuck(billingConfigsDuck, 'current')
  }
};


const SplitDepositManualPaymentModal = duckify(mapDucksToProps)(ManualPayment);


export default SplitDepositManualPaymentModal;

